import React from 'react';
import { components } from 'react-select';

import { LawOptionPropTypes } from 'src/components/JobChecklistForm/propTypes';
import s from './JobChecklistForm.styles';

const LawOptionComponent = ({ data, ...rest }) => {
  const description = [
    data.legalCitation,
    data.legalReqSummary,
    data.internalGuidelineInterpretation,
  ];

  return (
    <components.Option {...rest}>
      <s.LawTitle>{data.label}</s.LawTitle>
      <s.LawSecNumber>{data.articleSecNo}</s.LawSecNumber>
      <s.LawDescription>
        {description.filter(d => !!d).join('\n')}
      </s.LawDescription>
    </components.Option>
  );
};

LawOptionComponent.propTypes = LawOptionPropTypes;

export const LawOption = React.memo(LawOptionComponent);
